import { render, staticRenderFns } from "./attachmentsEditor.vue?vue&type=template&id=8436a0e4&scoped=true&"
import script from "./attachmentsEditor.vue?vue&type=script&lang=js&"
export * from "./attachmentsEditor.vue?vue&type=script&lang=js&"
import style0 from "./attachmentsEditor.vue?vue&type=style&index=0&id=8436a0e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8436a0e4",
  null
  
)

export default component.exports